import React from 'react';
import { Radio as MuiRadio, FormControlLabel } from '@mui/material';

const RadioButton = ({ checked, onChange, label, value, sx = {}, style = {}, ...props }) => {
  return (
    <FormControlLabel
      control={
        <MuiRadio 
          checked={checked}
          onChange={onChange}
          value={value}
          sx={{ ...style, ...sx }}
          {...props}
        />
      }
      label={label}
      sx={{ ...style, ...sx }}
    />
  );
};

export default RadioButton;
